/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */
import * as React from "react";
import { useSearchParams } from "react-router";

import { useAuth } from "@/providers";
import { PageLayout } from "@/shared/components";
import { UserProfile } from "@/shared/components/user";
import { Tab, Tabs, TabsList, TabsPanel } from "@/shared/foundation/primitives";

import styles from "./Account.module.css";
import { Preferences } from "./Preferences";
import { Tokens } from "./Tokens";

export const Account: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabSearchParam = searchParams.get("tab");
  const tabValue = tabSearchParam !== null ? parseInt(tabSearchParam) : 0;

  const { currentUser } = useAuth();

  return (
    <PageLayout title={"Roboto - Account"} headerContentLeft={"Account"}>
      <Tabs
        value={tabValue}
        onValueChange={(newValue: number) => {
          setSearchParams({ tab: String(newValue) });
        }}
      >
        <TabsList aria-label="Account" className={styles.tabs}>
          <Tab value={0}>Profile</Tab>
          <Tab value={1}>Tokens</Tab>
          <Tab value={2}>Preferences</Tab>
        </TabsList>

        <TabsPanel value={0}>
          <UserProfile user={currentUser} />
        </TabsPanel>
        <TabsPanel value={1}>
          <Tokens />
        </TabsPanel>
        <TabsPanel value={2}>
          <Preferences />
        </TabsPanel>
      </Tabs>
    </PageLayout>
  );
};
